import { Component, Inject, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, PdfExportProperties, ExcelExportProperties, IFilter, ToolbarItems, PdfExportService, ToolbarService, PageService, FilterService } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DateService } from 'src/app/date.service';
import { GlobalComponent } from 'src/app/global/global.component';
import { AgencyreportService } from './agencyreport.service';
import { AgencyreportdataService } from './agencyreportdata.service';
import { GetAgencyBO, columnWidth } from './agencyreport.model';
import { IMyDpOptions } from "mydatepicker";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-agencyreport',
  templateUrl: './agencyreport.component.html',
  styleUrls: ['./agencyreport.component.scss'],
  providers: [ToolbarService, PdfExportService, PageService, FilterService]
})

export class AgencyreportComponent implements OnInit {
  @ViewChild('grid') public grid: GridComponent;

  AgencyReportList: any = [];
  arraycol: any = [];
  ColumnArray: columnWidth[];

  FromDateFilter: any;
  EndDateFilter: any;
  type: string = "";

  AgencysendBO: GetAgencyBO = new GetAgencyBO();
  private onDestroy$: Subject<void> = new Subject<void>();

  initialPage: object;

  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  filterSettings: FilterSettingsModel;

  public data: Observable<DataStateChangeEventArgs>;

  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: "mm/dd/yyyy",
    showClearDateBtn: true,
    editableDateField: true,
  };

  constructor(public global: GlobalComponent, @Inject(AgencyreportdataService) public gethttp: AgencyreportdataService,
    public dateservice: DateService, public toasterService: ToastrService,
    public httpService: AgencyreportService, private cdr: ChangeDetectorRef,
    public datepipe: DatePipe
  ) {
    this.data = gethttp;
  }

  ngOnInit(): void {
    this.filterSettings = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    if (this.AgencysendBO.start != null && this.AgencysendBO.start != '' && this.AgencysendBO.start != undefined
      && this.AgencysendBO.end != null && this.AgencysendBO.end != undefined && this.AgencysendBO.end != '') {
      this.getoveralldata();
    }
  }

  //.......................................DateFormat.................................................
  DateFormat(event, type, name) {
    if (type == "inputchanged") {
      if (name == "SaveFromDate") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchange(event);
          this.AgencysendBO.start = element;
        }
      }
      if (name == "SaveEndDate") {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let element = this.dateservice.inputFeildchange(event);
          this.AgencysendBO.end = element;
        }
      }
    }
    if (type == "datechanged") {
      if (name == "SaveFromDate") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.AgencysendBO.start = element;
        }
      }
      if (name == "SaveEndDate") {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let element = this.dateservice.Datechange(event);
          this.AgencysendBO.end = element;
        }
      }
    }
  }
  //...............................................ApplyFilter....................................................
  ApplyFilter() {
    if (this.AgencysendBO.start == null || this.AgencysendBO.start == '' || this.AgencysendBO.start == undefined) {
      this.toasterService.error("select start date");
      return;
    }
    else if (this.AgencysendBO.end == null || this.AgencysendBO.end == undefined || this.AgencysendBO.end == '') {
      this.toasterService.error("select end date");
      return;
    }
    else if ((this.AgencysendBO.start != null && this.AgencysendBO.start != undefined && this.AgencysendBO.start != '')
      && (this.AgencysendBO.end != null && this.AgencysendBO.end != undefined && this.AgencysendBO.end != '')) {
      if (new Date(this.AgencysendBO.start).getTime() > new Date(this.AgencysendBO.end).getTime()) {
        this.toasterService.error("End date should greater than start date");
        return;
      }
    }
    this.AgencysendBO.start = this.global.getDateTimeString(this.AgencysendBO.start)
    this.AgencysendBO.end = this.global.getDateTimeString(this.AgencysendBO.end)
    this.getoveralldata();
  }
  // ................................................................................................................................
  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.grid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })

      var count = 0;
      var count1 = 0;
      if (args.columns.length > 0) {

        this.arraycol[0].Agencyreport.ShowColumns.forEach(old => {
          showarr.forEach(element => {
            if (old == element) {
              count1 = count1 + 1;
            }
          });
        });
        this.arraycol[0].Agencyreport.HideColumns.forEach(old => {
          hidearr.forEach(element => {
            if (old == element) {
              count = count + 1;
            }
          });
        });
        if (this.arraycol[0].Agencyreport.ShowColumns.length != count1 || this.arraycol[0].Agencyreport.HideColumns.length != count) {
          this.arraycol[0].Agencyreport.ShowColumns = showarr;
          this.arraycol[0].Agencyreport.HideColumns = hidearr;
        }
      }
    }

    this.AgencysendBO.currentpageno = this.grid.pagerModule.pagerObj.currentPage;
    this.AgencysendBO.pageitem = this.grid.pagerModule.pagerObj.pageSize;
  }

  public dataStateChange(state): void {
    this.type = (state.action.requestType).toString();
    if (this.type != "filterchoicerequest") {
      if ((state.sorted || []).length) {
        this.AgencysendBO.orderColumn = state.sorted[0].name;
        this.AgencysendBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (this.type == "filtering" && state.action.action != "clearFilter") {
      this.AgencysendBO.field = state.action.currentFilterObject.field;
      this.AgencysendBO.matchCase = state.action.currentFilterObject.matchCase;
      this.AgencysendBO.operator = state.action.currentFilterObject.operator;
      this.AgencysendBO.value = state.action.currentFilterObject.value;
      this.AgencysendBO.currentpageno = 1;
      this.AgencysendBO.pageitem = JSON.parse(this.global.globalColumn.column)[0].Agencyreport.Pagesize;
      this.grid.pageSettings.pageSize = JSON.parse(this.global.globalColumn.column)[0].Agencyreport.Pagesize
      this.grid.pageSettings.currentPage = 1;
    }
    else {
      if (this.type == "filtering" && state.action.action == "clearFilter") {
        this.AgencysendBO.field = "agencyName";
        this.AgencysendBO.matchCase = false;
        this.AgencysendBO.operator = "startswith";
        this.AgencysendBO.value = "";
        this.AgencysendBO.currentpageno = 1;
        this.AgencysendBO.pageitem = JSON.parse(this.global.globalColumn.column)[0].Agencyreport.Pagesize;
        this.grid.pageSettings.pageSize = JSON.parse(this.global.globalColumn.column)[0].Agencyreport.Pagesize
        this.grid.pageSettings.currentPage = 1;
      }
    }

    this.getoveralldata();
    if (this.type == "paging" && state.action.name == "actionBegin") {
      if (this.arraycol.length != 0) {
        if (this.arraycol[0].Agencyreport.Pagesize != state.take) {
          this.arraycol[0].Agencyreport.Pagesize = state.take
        }
      }
    }
  }

  Refresh() {
    this.grid.pageSettings.currentPage = 1;
    this.AgencysendBO.field = 'agencyName';
    this.AgencysendBO.value = "";
    this.AgencysendBO.currentpageno = 1;
    this.AgencysendBO.start = ''
    this.AgencysendBO.end = ''
    this.grid.dataSource = []
  }

  getoveralldata() {
    if (this.AgencysendBO.start == null || this.AgencysendBO.start == '' || this.AgencysendBO.start == undefined) {
      this.toasterService.error("select start date");
      return;
    }
    else if (this.AgencysendBO.end == null || this.AgencysendBO.end == undefined || this.AgencysendBO.end == '') {
      this.toasterService.error("select end date");
      return;
    }
    else if ((this.AgencysendBO.start != null && this.AgencysendBO.start != undefined && this.AgencysendBO.start != '')
      && (this.AgencysendBO.end != null && this.AgencysendBO.end != undefined && this.AgencysendBO.end != '')) {
      if (new Date(this.AgencysendBO.start).getTime() > new Date(this.AgencysendBO.end).getTime()) {
        this.toasterService.error("End date should greater than start date");
        return;
      }
    }
    this.AgencysendBO.start = this.global.getDateTimeString(this.AgencysendBO.start)
    this.AgencysendBO.end = this.global.getDateTimeString(this.AgencysendBO.end)
    this.gethttp.execute(this.AgencysendBO);

    this.AgencysendBO.start = (this.AgencysendBO.start != null && this.AgencysendBO.start != undefined && this.AgencysendBO.start != "") ? this.datepipe.transform(this.AgencysendBO.start, "MM/dd/yyyy") : null;
    this.AgencysendBO.end = (this.AgencysendBO.end != null && this.AgencysendBO.end != undefined && this.AgencysendBO.end != "") ? this.datepipe.transform(this.AgencysendBO.end, "MM/dd/yyyy") : null;

    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {

    })
  }

  exceldownload() {
    let getBO = JSON.parse(JSON.stringify(this.AgencysendBO));
    this.httpService.getExcel(getBO).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      let contentType = 'text/csv';
      const blob = this.b64toBlob(data.fileContents, contentType);
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = "Agency Report";
      a.click();
    })
  }

  b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {

    const byteCharacters = atob(b64Data);

    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {

      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);

      for (let i = 0; i < slice.length; i++) {

        byteNumbers[i] = slice.charCodeAt(i);

      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);

    }

    const blob = new Blob(byteArrays, { type: contentType });

    return blob;

  }

  async pdfdownload() {
    let getBO = JSON.parse(JSON.stringify(this.AgencysendBO));
    this.httpService.getExcel(getBO).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      const pdfExportProperties: PdfExportProperties = {
        pageOrientation: 'Landscape',
        dataSource: data.overalldata,
        fileName: 'AgencyReport' + new Date().toISOString().replace("Z", "") + '.pdf'
      }
      var count = 0;

      this.grid.pdfExport(pdfExportProperties);
    })
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
}
